<script>
import PrettyDateRange from '@/components/PrettyDateRange.vue'
import { useCartStore } from '@/cart/stores/cart'

export default {
  name: 'CartEventHero',

  components: {
    PrettyDateRange,
  },

  data() {
    return {
      cartStore: useCartStore(),
    }
  },

  computed: {
    currentEvent() {
      return this.cartStore.selectedEvent
    },

    heroStyle() {
      const url = this.currentEvent && this.currentEvent.backgroundImage
      if (!url) {
        return {}
      }
      return {
        backgroundImage:
          `linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.6)), url(${url})`,
      }
    },

    eventName() {
      return (this.currentEvent && this.currentEvent.name) || ''
    },

    eventLocation() {
      return (this.currentEvent && this.currentEvent.locationLabel) || ''
    },
  },
}
</script>

<template>
  <div class="cart-event-hero">
    <div class="cart-event-hero__image" :style="heroStyle">
      <div v-if="currentEvent" class="cart-event-hero__content">
        <p class="cart-event-hero__eyebrow">Music Festival</p>
        <h1 class="cart-event-hero__title">
          {{ eventName }}
        </h1>
        <p class="cart-event-hero__meta">
          <b-icon icon="calendar-blank" size="is-small" class="mr-1" />
          <span>
            <PrettyDateRange :start="currentEvent.startDate" :end="currentEvent.endDate" />
          </span>
          <span v-if="eventLocation" class="mx-2">•</span>
          <template v-if="eventLocation">
            <b-icon icon="map-marker" size="is-small" class="mr-1" />
            <span>{{ eventLocation }}</span>
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cart-event-hero {
  width: 100%;
  height: 260px;
  margin: -1.5rem 0 1.5rem;
  background-color: #111827;
  overflow: hidden;
}

.cart-event-hero__image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  display: flex;
  align-items: flex-end;
}

.cart-event-hero__content {
  padding: 1.25rem 1.5rem;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(15, 23, 42, 0.9);
}

.cart-event-hero__eyebrow {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.9;
}

.cart-event-hero__title {
  font-size: 1.4rem;
  font-weight: 700;
}

.cart-event-hero__meta {
  margin-top: 0.25rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

@media (min-width: 769px) {
  .cart-event-hero {
    height: 360px;
  }
}
</style>
